import { Map, List, fromJS } from 'immutable';

export function request(state, { userId }) {
    state = state.setIn([ 'accept-referred-betslip', userId ], Map({
        state: 'IN_PROGRESS'
    }));

    return state;
}

export function error(state, { userId, errors }) {
    state = state.setIn([ 'accept-referred-betslip', userId ], Map({
        state: 'ERROR',
        errors: fromJS(errors)
    }));

    return state;
}

export function finish(state, { userId, bets }) {
    return state
        .removeIn([ 'possibleBets', userId ])
        .setIn([ 'combinations', userId ], List())
        .setIn([ 'bets', userId ], List())
        .setIn([ 'legs', userId ], Map())
        .setIn([ 'multiples', userId ], Map())
        .setIn([ 'accept-referred-betslip', userId ], Map({
            state: 'FINISHED',
            errors: void 0,
            bets: bets
        }));
}

export function clear(state, { userId }) {
    return state.removeIn([ 'accept-referred-betslip', userId ]);
}
